import React from 'react';

import PersonIcon from '@mui/icons-material/Person';

import CONSTANTS from 'src/constants/common';
import { Image } from 'src/@types';

export default function UsuariaAvatar({
  perfil_foto,
  size,
}: {
  perfil_foto?: Image | null;
  size?: number;
}) {
  if (!perfil_foto) {
    return <PersonIcon />;
  }

  const url = CONSTANTS.API.url + perfil_foto.url;

  return (
    <img
      src={url}
      alt="menu de usuaria"
      title="menu de usuaria"
      style={{
        width: size || 40,
        height: size || 40,
        objectFit: 'cover',
        borderRadius: '50%',
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: '#FFF',
      }}
    />
  );
}
